import { Communicator, setupPostQuecast } from '@wikia/post-quecast';
import { fromEventPattern } from 'rxjs';
import { shareReplay, filter } from 'rxjs/operators';
class CommunicationService {
    constructor() {
        setupPostQuecast();
        this.communicator = new Communicator();
        this.actions = fromEventPattern((handler) => this.communicator.addListener(handler), (handler) => this.communicator.removeListener(handler)).pipe(shareReplay({ refCount: true }));
    }
    dispatch(action) {
        this.communicator.dispatch(Object.assign(Object.assign({}, action), { __global: true }));
    }
}
let communicationService = null;
export function getCommunicationService() {
    if (communicationService === null) {
        communicationService = new CommunicationService();
    }
    return communicationService;
}
export function ofType(...types) {
    return (source) => {
        return source.pipe(filter((action) => types.some((type) => action.type === type)));
    };
}
